import {React, useState} from 'react'
import { useHistory } from 'react-router-dom'
import IIotSolutions from '../../assets/IAGeneric/IIotSolutions.png'//*1
import IAHome from '../../assets/home-icon.svg'

import content from '../content.json'

import CPSMenu from '../CPSMenu/CPSMenu'


import './SolutionInformation.scss'

import Arrow from '../../assets/IAGeneric/Arrow.png'
import { IAVisual } from '../IAVisual/IAVisual'
import { Hotspot, HotspotLegend } from '../IAVisual/components/Hotspot'

function IIotSolutionspage (){//*4

    let history = useHistory()

    const [active, setActive] = useState('ENCLOSURES')

    const [imageLoaded, setImageLoaded] = useState(false);
    const [bottomOpen, setbottomOpen] = useState(false);

    const toggleNavbar = () => {
        setbottomOpen(
          bottomOpen => !bottomOpen
        );
      }

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
  
    let rightOpen = 'open'

    const applicationSolutionImage = window.location.pathname.split('/')[3]

    const images = {
        "IIotSolutions": ["IIotSolutions", IIotSolutions, '']//*2
    }

    var image;
    image = content[applicationSolutionImage]?.media
    const solutionImages = Object.keys(image)

    return (
        <div id='solution-layout'>
          <div className={bottomOpen ? 'nav-close' : 'invisible'} onClick={toggleNavbar}></div>

<nav className={bottomOpen ? 'nav-bottom nav-open': 'nav-bottom'}>
            
            <a href="#" class="nav-toggle" onClick={toggleNavbar}></a>
            <div className="nav-toggle-image-container" onClick={toggleNavbar}></div>
            

            <div className="nav-grid-4-columns">
              <div className="nav-grid-item">
                <HotspotLegend
                  content={content.ControlPanelSolutions}
                 
                />
                <h2> Control Panel Solutions </h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.IndustrialComputing}
                       
                />
                <h2>Industrial Computing</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.MachineSafety}
                       
                />
                <h2> Machine Safety </h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.MotionControls}
                        
                />
                <h2> Motion Controls</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Networking}
                        
                />
                <h2> Networking</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.OperatorInterface}
                       
                />
                <h2> Operator Interface + HMI</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.PowerMonitoring}
                        
                />
                <h2> Power Monitoring</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Sensors}
                        
                />
                <h2> Sensors</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Cybersecurity}
                        
                />
                <h2> Cybersecurity</h2>
              </div>


              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Pneumatics}
                        
                />
                <h2> Pneumatics</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.IIotSolutions}
                       
                />
                <h2> Industrial Internet of Things</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Drives}
                        
                />
                <h2> Drives</h2>
              </div>
            </div>

        </nav>


            <div id='solution-main'>
                <div className='solution-header'>
                    <h3 className={`
                        solution-title
                        ${'right-' + rightOpen}
                    `}>
                    </h3>
                </div>
                        <div className='overview-main-content'> 
                        <IAVisual IIotSolutions="true"/>
                        </div>
            </div>
    
            
            <div id='right' className={rightOpen} >
                <img
                    alt="IA Home Icon"
                    className="home-icon"
                    src={IAHome}
    
                    onClick={ () => history.push('/ia-graphic')}
                />
                    <div className={`solution-sidebar ${rightOpen}`} >
                        <div className='solution-header'>
                        </div>
                        <div className='solution-sidebar-content'>
                            <p>
                                <div className="sidebarContainer">
                                    <div className="sidebarList">
                                        {solutionImages?.map((item, index) => {
                                            return(
                                            <div className='cardImages' key={item}>
                                                <div className="sidebarCard" >
    
                                             <table>
                                                <tr>
                                                  <td>
                                                        <img
                                                            alt="IA graphic"
                                                            className="solution-md-image"
                                                            src={image[item][0]}
                                                            onClick={ 
                                                                () => image[item][1] !== "" ? window.open(image[item][1],""): "" 
                                                            }
                                                        /> 
                                                        </td>
                                                    <td>
                                                        <div className='overlay'>
                                                        <img
                                                        alt ='arrow image'
                                                        className = 'Arrow'
                                                        src ={Arrow}
                                                        onClick={ 
                                                            () => image[item][1] !== "" ? window.open(image[item][1],""): "" 
                                                        }
                                                        />
                                                        </div>
                                                        </td>
                                                      </tr>
    
                                                </table>   
    
                                                </div>
                                                <p style={{color:'white', fontSize:'medium', margin:'0px 0px 20px 5px'}}>{item}</p>
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            </p>
                        </div>
                    </div>
                {/* </div> */}
            </div>
    
        </div>
        );

}

export default  IIotSolutionspage//*3